import { useState } from "react"
import {
    Box,
    TextField,
    Button,
    IconButton,
    Paper,
    Stack,
    Divider
} from '@mui/material'
import {
    ContentCopy,
    Refresh,
    Visibility,
    VisibilityOff
} from '@mui/icons-material'

export default function PasswordBox() {
    const [password, setPassword] = useState("")
    const [length, setLength] = useState(16)
    const [useUppercase, setUseUppercase] = useState(true)
    const [useNumbers, setUseNumbers] = useState(true)
    const [useSymbols, setUseSymbols] = useState(true)
    const [showPassword, setShowPassword] = useState(false)

    const generatePassword = () => {
        let charset = "abcdefghijklmnopqrstuvwxyz"
        if (useUppercase) charset += "ABCDEFGHIJKLMNOPQRSTUVWXYZ"
        if (useNumbers) charset += "0123456789"
        if (useSymbols) charset += "!@#$%^&*()_+-=[]{}|;:,.<>?"

        let newPassword = ""
        for (let i = 0; i < length; i++) {
            newPassword += charset.charAt(Math.floor(Math.random() * charset.length))
        }
        setPassword(newPassword)
    }

    const copyToClipboard = async () => {
        if (password) {
            await navigator.clipboard.writeText(password)
        }
    }

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword)
    }

    return (
        <Box sx={{ width: '100%', maxWidth: 600, mx: 'auto' }}>
            <Paper
                elevation={3}
                sx={{
                    p: 4,
                    borderRadius: 3,
                    background: 'rgba(255, 255, 255, 0.95)',
                    backdropFilter: 'blur(10px)',
                }}
            >

                <Stack spacing={3}>
                    {/* Campo de senha */}
                    <Box sx={{ position: 'relative' }}>
                        <TextField
                            fullWidth
                            value={password}
                            placeholder="Sua senha aparecerá aqui"
                            variant="outlined"
                            size="medium"
                            type={showPassword ? "text" : "password"}
                            InputProps={{
                                readOnly: true,
                                sx: {
                                    fontSize: '1.1rem',
                                    fontFamily: 'monospace',
                                    pr: 16
                                }
                            }}
                        />
                        <Box sx={{
                            position: 'absolute',
                            right: 8,
                            top: '50%',
                            transform: 'translateY(-50%)',
                            display: 'flex',
                            gap: 1
                        }}>
                            <IconButton
                                onClick={togglePasswordVisibility}
                                size="small"
                                sx={{ color: 'text.secondary' }}
                                title={showPassword ? "Esconder senha" : "Mostrar senha"}
                            >
                                {showPassword ? <VisibilityOff /> : <Visibility />}
                            </IconButton>
                            <IconButton
                                onClick={copyToClipboard}
                                size="small"
                                sx={{ color: 'text.secondary' }}
                                title="Copiar senha"
                            >
                                <ContentCopy />
                            </IconButton>
                            <IconButton
                                onClick={generatePassword}
                                size="small"
                                sx={{ color: 'text.secondary' }}
                                title="Gerar nova senha"
                            >
                                <Refresh />
                            </IconButton>
                        </Box>
                    </Box>

                    <Divider />

                    {/* Botões de ação */}
                    <Stack direction="row" spacing={2}>
                        <Button
                            variant="outlined"
                            onClick={copyToClipboard}
                            startIcon={<ContentCopy />}
                            fullWidth
                            size="large"
                            disabled={!password}
                        >
                            Copiar Senha
                        </Button>
                        <Button
                            variant="contained"
                            onClick={generatePassword}
                            startIcon={<Refresh />}
                            fullWidth
                            size="large"
                            sx={{
                                bgcolor: '#ff5722',
                                '&:hover': {
                                    bgcolor: '#e64a19',
                                },
                            }}
                        >
                            Gerar Senha
                        </Button>
                    </Stack>
                </Stack>
            </Paper>
        </Box>
    )
}